// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailSent_root__-qsVO"};